import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";

export default function FinancialDashboard(props) {
    const [iframeUrl, setiframeUrl] = useState('');
    const [isIframeLoading, setIsIframeLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        axios
            .get(APIURL + "/metabase/financialDashboard", {
                params: { companyID: props.user.comp_id, companyName: props.user.company_name },
            })
            .then((response) => {
                setiframeUrl(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleIframeLoad = () => {
        setIsIframeLoading(false);
    };

    return (
        <div>
            <div style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>
                <iframe
                    src={iframeUrl}
                    style={{ width: '100%', height: '80vh', border: 'none', backgroundColor: 'transparent', colorScheme: 'light' }}
                    allowTransparency
                    onLoad={handleIframeLoad}
                />
            </div>
        </div>
    );
};